export const VERSION = "1.16.0";


// WEBPACK FOOTER //
// ../lib/env/data.js